import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import { Base } from "../../base";
import { Close } from "@mui/icons-material";
import { useSelector } from "../../../store";
import JobGroup from "../../../types/jobGroup";
import ColumnDef from "../../../types/columnDef";
import { GridCellParams } from "@mui/x-data-grid";
import theme from "../../../theme";

interface Props {
  open: boolean;
  setWeeklyDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

const WeeklyHighlights: React.FC<Props> = (props) => {
  const { open, setWeeklyDrawer } = props;
  const { weeklyHighlight } = useSelector((store) => store.job);
  const [expanded, setExpanded] = useState<string | false>(false);
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const titleColumn: ColumnDef[] = [
    {
      field: "title",
      headerName: "Title",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      mobileSize: 12,
    },
  ];

  const siteColumn: ColumnDef[] = [
    ...titleColumn,
    {
      field: "site",
      headerName: "Site",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      mobileSize: 12,
    },
  ];

  const actionsColumn: ColumnDef = {
    field: "actions",
    headerName: "Actions",
    headerAlign: "center",
    align: "center",
    flex: 1,
    headerClassName: "header",
    sortable: false,
    disableColumnMenu: true,
    disableExport: true,
    filterable: false,
    renderCell: (params) => <>{params.value}</>,
    mobileSize: 12,
  };

  const displayRows = (array: any) => {
    return array.map((job: JobGroup) => {
      let rowObject = {
        id: job.id,
        title: job.title,
        site: job.id > 0 ? job.siteName ?? "N/A" : "",
        mobileTitle: `${job.title}- ${job.siteName}`,
        actions: (
          <Base.TableActions
            id={job.id}
            handleView={() =>
              window.open(
                `/job/view/${job.id}`,
                "_blank",
                "noopener,noreferrer",
              )
            }
          />
        ),
      };
      return rowObject;
    });
  };

  const tableDisplay = (
    title: string,
    jobArray: JobGroup[],
    badgeCount: number,
    expanded: boolean,
    onChange: (event: React.SyntheticEvent, expanded: boolean) => void,
  ) => {
    return (
      <Grid
        sx={{
          width: "100%",
        }}
        key={title}
      >
        <Base.AccordionSwitch
          title={title}
          expanded={expanded}
          onChange={onChange}
          badgeNumber={badgeCount}
          color={theme.palette.primary.light}
          alwaysAccordion
          content={
            <Base.TableContainer
              rows={displayRows(jobArray)}
              columns={
                jobArray.some((j) => !!j.siteId)
                  ? [
                      ...siteColumn,
                      ...(jobArray.some((j) => j.completedOn === null)
                        ? [actionsColumn]
                        : []),
                    ]
                  : [
                      ...titleColumn,
                      ...(jobArray.some((j) => j.completedOn === null)
                        ? [actionsColumn]
                        : []),
                    ]
              }
              totalRows={jobArray.length}
              mobileRows={displayRows(jobArray)}
              pageSize={jobArray.length < 15 ? 15 : jobArray.length}
              getCellClassName={(params: GridCellParams<any, any, any>) => {
                return "link";
              }}
              mobileBackgroundColor="white"
            />
          }
        />
      </Grid>
    );
  };

  return (
    <Base.Modal open={open} onClose={() => setWeeklyDrawer(false)}>
      <Box
        sx={{
          width: { sm: 600, xs: 300 },
          display: "flex",
          paddingX: 3,
          paddingTop: 2,
          borderRadius: "15px",
          flexDirection: "column",
          backgroundColor: theme.palette.background.paper,
          "& .header": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
        }}
      >
        <Box sx={{ alignSelf: "flex-end" }}>
          <Base.IconButton
            icon={<Close />}
            label="Close"
            onClick={() => setWeeklyDrawer(false)}
          />
        </Box>
        <Grid container direction={{ xs: "column" }} spacing={2} pb={5}>
          {tableDisplay(
            "Sunday",
            weeklyHighlight.sunday,
            weeklyHighlight.sunday.length,
            expanded === "panel1",
            handleChange("panel1"),
          )}
          {tableDisplay(
            "Monday",
            weeklyHighlight.monday,
            weeklyHighlight.monday.length,
            expanded === "panel2",
            handleChange("panel2"),
          )}
          {tableDisplay(
            "Tuesday",
            weeklyHighlight.tuesday,
            weeklyHighlight.tuesday.length,
            expanded === "panel3",
            handleChange("panel3"),
          )}
          {tableDisplay(
            "Wednesday",
            weeklyHighlight.wednesday,
            weeklyHighlight.wednesday.length,
            expanded === "panel4",
            handleChange("panel4"),
          )}
          {tableDisplay(
            "Thursday",
            weeklyHighlight.thursday,
            weeklyHighlight.thursday.length,
            expanded === "panel5",
            handleChange("panel5"),
          )}
          {tableDisplay(
            "Friday",
            weeklyHighlight.friday,
            weeklyHighlight.friday.length,
            expanded === "panel6",
            handleChange("panel6"),
          )}
          {tableDisplay(
            "Saturday",
            weeklyHighlight.saturday,
            weeklyHighlight.saturday.length,
            expanded === "panel7",
            handleChange("panel7"),
          )}
        </Grid>
      </Box>
    </Base.Modal>
  );
};

export default WeeklyHighlights;
